// extracted by mini-css-extract-plugin
export default {"rect":"Chart_rect__8+Rcj","vertical":"Chart_vertical__IGw1t","horizontal":"Chart_horizontal__-hbMv"};